import type { SVGProps } from 'react'
const SvgSyCloseSquare = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={9} fillOpacity={0.24} />
		<g strokeLinecap="square" strokeLinejoin="round">
			<path d="m16 7.152-.424.424-8 8-.424.424.848.848.424-.424 8-8L16.848 8z" />
			<path d="M8 7.152 7.152 8l.424.424 8 8 .424.424.848-.848-.424-.424-8-8z" />
		</g>
	</svg>
)
export default SvgSyCloseSquare
